/*
 * @Author: HB-BruceWang
 * @Date: 2025-02-12 16:22:12
 * @LastEditors: HB-BruceWang
 * @LastEditTime: 2025-02-27 14:52:10
 * @FilePath: \shopify-web\src\pages\paid-extended-warranty\snippets\form\js\file-upload.js
 * @Description:付费延保表单- 购买凭证版块
 * 1. 使用AWS S3桶存储图片，可增加可删除
 * 2. 上传可预览图片
 *
 * Copyright (c) 2025 by Hello Tech, All Rights Reserved.
 */

import { getAwsS3Data } from "@utils/api.js";
export function renderFileUpload(validateFormTwo, ValidateMessages) {
  const $uploadProof = $('#pewFormTwo #upload_proof');

  // 购买凭证清单
  let attachmentsUrls = JSON.parse($uploadProof.attr('data-img-urls')) || [];

  let s3keys = JSON.parse($uploadProof.attr('data-s3keys') || []);

  // 上传中
  let isUploading = $uploadProof.attr('data-uploading') === 'true';

  // 凭证图片数量，最多3张
  let total = $uploadProof.attr('data-total');

  // 购买凭证相关数据 重置
  const resetData = (type) => {
    attachmentsUrls = [];
    isUploading = false;
    total = 0;
    $('#pewFormTwo .add-image').show();
    $('#pewFormTwo .preview-image').remove();
    $uploadProof.attr('data-uploading', false).attr('data-total', 0).attr('data-img-urls', '[]').attr('data-s3keys', '[]');

    if (type === 'delete') {
      // 未提交表单前，刷线页面或关闭页面，清空S3桶当前页面上传的所有凭证图片
      DeleteAllProofsFromS3(s3keys);
    }
    s3keys = [];
  }

  /**
  * 上传到S3桶并获取文件回传地址
  * @param {*} params 文件数据
  * @param {*} s3Config s3验证信息
  * @param {*} callback 回调函数
  * @returns
  */
  const uploadToS3 = (params, s3Config, callback) => {
    const { file, filename } = params;
    return new Promise((resolve, reject) => {
      const filePath = filename;
      let { access_key_id, secret_access_key, session_token, region, bucket } = s3Config;
      let s3Param = { Bucket: bucket, Key: filePath, Body: file, ContentType: file.type };
      let s3Client = new window.AWS.S3({ accessKeyId: access_key_id, secretAccessKey: secret_access_key, sessionToken: session_token, region });

      // 分片上传, 每5M分片, 5 * 1024 * 1024
      let queueSize = Math.ceil(file.size / 5242880);
      let upload = s3Client.upload(s3Param, {
        partSize: file.size < 5242880 ? 5242880 : file.size, queueSize,
        httpOptions: { connectTimeout: 60 * 1000 * 10, timeout: 60 * 1000 * 10 }
      }).on("httpUploadProgress", function (e) {
        callback && callback(e)
      });

      upload.send(function (err, data) {
        err ? reject(err) : resolve(data)
      })
    })
  }

  /**
   * 从s3桶删除对应文件
   * @param {*} s3key s3桶 key
   */
  const deleteFromS3 = async (s3key) => {
    const info = await getAwsS3Data();
    let { access_key_id, secret_access_key, session_token, region, bucket } = info.data;
    let s3Client = new window.AWS.S3({ accessKeyId: access_key_id, secretAccessKey: secret_access_key, sessionToken: session_token, region });
    await s3Client.deleteObject({
      Bucket: bucket,
      Key: s3key
    }).promise();
  }

  // 删除当前页面上传的所有凭证图片
  const DeleteAllProofsFromS3 = async (currS3keys) => {
    const info = await getAwsS3Data();
    let { access_key_id, secret_access_key, session_token, region, bucket } = info.data;
    let s3Client = new window.AWS.S3({ accessKeyId: access_key_id, secretAccessKey: secret_access_key, sessionToken: session_token, region });
    const objectsToDelete = currS3keys.map((key) => ({ Key: key }));

    await s3Client.deleteObjects({
      Bucket: bucket,
      Delete: {
        Objects: objectsToDelete,
        Quiet: false // 显示删除结果详情
      }
    }).promise();
  }

  // 预览图渲染
  const imgPreviewRender = (imgUrl, s3key, index) => {
    const imgHtml = `
    <div class="list-item preview-image">
      <img src="${imgUrl}" alt="Receipt preview" width="80" height="80">
      <span class="icon-close" data-s3key="${s3key}" data-index="${index}">×</span>
    </div>
    `
    $('#pewFormTwo .img-list').prepend(imgHtml);
  }

  //  文件上传
  const fileUpload = (file) => {
    let type = file.name.split(".");
    type = type[type.length - 1].toLowerCase();
    validateFormTwo.revalidateField('#upload_proof').then(async isValid => {
      if (isValid) {
        // 有数据，上传中
        isUploading = true;
        $uploadProof.attr('data-uploading', isUploading); 
        validateFormTwo.showErrors({ '#upload_proof': ValidateMessages.imgUploading });

        // 图片格式 大小 均符合要求，上传S3桶
        const info = await getAwsS3Data();
        uploadToS3({ file, filename: `paid-extended-warranty/${new Date().getTime()}.${type}` }, info.data, null)
          .then((s3) => {
            const currUrl = `https://${s3.Bucket}/${s3.key}`;
            attachmentsUrls.push(currUrl);
            s3keys.push(s3.key);
            $uploadProof.attr('data-img-urls', JSON.stringify(attachmentsUrls)).attr('data-s3keys', JSON.stringify(s3keys));

            imgPreviewRender(currUrl, s3.key, attachmentsUrls.length - 1);
          })
          .catch((err) => {
            total > 0 ? --total : 0;
            $uploadProof.attr('data-total', total);
            if (total < 3) {
              $('#pewFormTwo .add-image').show();
            }
            validateFormTwo.showErrors({ '#upload_proof': err.message });
          })
          .finally(() => {
            // 重置以便下次触发
            $uploadProof[0].value = '';
            isUploading = false;
            $uploadProof.attr('data-uploading', isUploading);
            validateFormTwo.revalidateField('#upload_proof');
          })
      } else {
        // 不符合图片格式和大小要求，重置以便下次触发
        $uploadProof[0].value = '';
        isUploading = false;
        $uploadProof.attr('data-uploading', isUploading);

        total > 0 ? --total : 0;
        $uploadProof.attr('data-total', total);
        if (total < 3) {
          $('#pewFormTwo .add-image').show();
        }
      }
    })
  }

  // 购买凭证事件监听
  const proofListEventListener = () => {
    // 点击删除图片
    $('#pewFormTwo .img-list').off('click').on('click', '.icon-close', async function () {
      try {
        $uploadProof.attr('data-total', --total);
        if (total < 3) {
          $('#pewFormTwo .add-image').show();
        }

        $(this).parent().remove();
        const crrImgUrl = $(this).prev().attr('src');
        attachmentsUrls = attachmentsUrls.filter(item => item != crrImgUrl);

        const crrS3key = $(this).data('s3key');
        s3keys = s3keys.filter(item => item != crrS3key);

        $uploadProof.attr('data-img-urls', JSON.stringify(attachmentsUrls)).attr('data-s3keys', JSON.stringify(s3keys));

        const s3key = $(this).data('s3key');
        deleteFromS3(s3key);

        if (attachmentsUrls.length === 0) {
          $uploadProof.val('');
          validateFormTwo.revalidateField('#upload_proof');
        }
      } catch (error) {
        console.error('Delete Error:', error);
      }
    })

    // 点击添加图片触发
    $('#pewFormTwo .add-image').off('click').on('click', function () {
      if (!$uploadProof[0].value) {
        $uploadProof.trigger('click');
      }
    })

    // 图片凭证相关数据 重置
    $('#pewFormTwo .add-image').on('resetEvent', function () {
      resetData('reset');
    });

    // 线上渠道提交，需要判断是否之前上传过图片，若有则删除
    $('#pewFormTwo .add-image').on('onlineCheckProofEvent', function () {
      if (attachmentsUrls.length > 0) {
        resetData('delete');
      }
    });

    // 监听用户上传图片
    $uploadProof[0].addEventListener('change', function (e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files.length) {
        ++total;
        $uploadProof.attr('data-total', total);
        if (total === 3) {
          // 上传3张，隐藏添加按钮
          $('#pewFormTwo .add-image').hide();
        }

        fileUpload(files[0]);
      } else {
        isUploading = false;
        $uploadProof.attr('data-uploading', isUploading);
        validateFormTwo.revalidateField('#upload_proof');

        // 重置以便下次触发
        $uploadProof[0].value = '';
      }
    })
  }

  proofListEventListener();

  // 用户刷新或关闭页面，触发校验弹窗并点击确认后执行
  window.addEventListener('unload', () => {
    resetData('delete');
  });
}